import styles from "./DeleteConfirmation.module.css";
import Backdrop from "../../Catalogs/Dialog/Backdrop";

export const CancelOrderConfirmation = ({
  show,
  handleCancel,
  handleConfirm,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  cancelLabel = "Cancel",
  confirmLabel = "Confirm",
}) => {
  if (!show) return null;

  return (
    <div>
      <Backdrop show={show} switch={handleCancel} />
      <div className={styles.deleteDialog}>
        <h2 className={styles.deleteTitle}>{title}</h2>
        <p className={styles.deleteMessage}>{message}</p>
        <div className={styles.buttonContainer}>
          <button className={styles.cancelButton} onClick={handleCancel}>
            {cancelLabel}
          </button>
          <button className={styles.deleteButton} onClick={handleConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
